import { memo, useMemo } from 'react'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateQuantityGift } from './use-update-quantity-gift'

export const QuantityGiftSent = memo(() => {
  useUpdateQuantityGift()

  const notifyGiftSentQuantityList = useGlobalStore((state) => {
    return state.notifyGiftSentQuantityList
  })

  const toasts = useMemo(
    () =>
      Object.keys(notifyGiftSentQuantityList)?.map((key) => {
        return notifyGiftSentQuantityList[key]
      }),
    [notifyGiftSentQuantityList],
  )

  return (
    <div className="w-screen h-screen flex justify-center flex-col gap-2">
      {toasts?.map(
        (toast, index) => index < 3 && <Toast key={toast.id} toast={toast} />,
      )}
    </div>
  )
})
